export const ReplaceWords=(value:any,words?:ObjectType<string>)=>{
    
    let sentence=value;

    if(words &&  typeof words === "object" && sentence as string ){
        Object.keys(words as  ObjectType<string>).forEach(key=>{
         
            sentence=sentence.replace(`:${key}`,words[key]);  
        });
    }

    return sentence; 
}